var map = {
	"./add-icon.svg": "dd04",
	"./ag-black.svg": "bf31",
	"./ag-blue.svg": "333af",
	"./ag-mini.svg": "2d1e",
	"./ag-white-logo.svg": "358c",
	"./akar-icons_arrow-left.svg": "10b7",
	"./analytic.svg": "9900",
	"./arrow-back.svg": "95cd",
	"./arrow-left-icon.svg": "719c3",
	"./arrow-left-yellow.svg": "7377",
	"./arrow-right-green.svg": "be41",
	"./arrow-sidebar-left.svg": "a445",
	"./arrow-sidebar-right.svg": "6600",
	"./arrow-theme-down.svg": "c276",
	"./arrow_step_in_right.svg": "4f5e",
	"./bi_calendar-check.svg": "36a5",
	"./calendar-grey.svg": "3ec1",
	"./calendar-icon.svg": "1b93",
	"./cancel-icon.svg": "faec",
	"./change-arrow.svg": "0693",
	"./check-green.svg": "09a9",
	"./check-r-k.svg": "41b2",
	"./clock-icon.svg": "5a8c",
	"./close-modal-icon.svg": "eced",
	"./close-r-k.svg": "98ba",
	"./close-red-icon.svg": "2d41",
	"./doc-instruction-icon.svg": "53e7",
	"./edit-icon.svg": "35d7",
	"./email-icon-black.svg": "fc57",
	"./email-icon.svg": "f97a",
	"./empty-bookings-icon.svg": "3a3e",
	"./exit-icon.svg": "693d",
	"./eye-close.svg": "8fca",
	"./eye-open.svg": "3b1b",
	"./gg_close.svg": "762e",
	"./guest-icon.svg": "b588",
	"./guests.svg": "6de2",
	"./hall.svg": "1a96",
	"./hall/calendar-check-icon.svg": "60d3",
	"./hall/calendar-filter.svg": "e195",
	"./hall/chair-filter.svg": "f1d6",
	"./hall/chair-icon.svg": "4de2",
	"./hall/closed-booking-icon.svg": "33ae",
	"./hall/closure.svg": "5a84",
	"./hall/count-place-icon.svg": "bdf2",
	"./hall/location.svg": "c02e",
	"./hall/not-read.svg": "3efb",
	"./hall/paid-filter.svg": "39f7",
	"./hall/stat-arrow.svg": "8246",
	"./hall/time-closure-icon.svg": "f575",
	"./hall/time-filter.svg": "97a4",
	"./hall/time-new-icon.svg": "ddec",
	"./hall/time-wait-icon.svg": "edd1",
	"./hall/timer-icon.svg": "45bf",
	"./hall/to-close-icon.svg": "31ab",
	"./hostes-icon.svg": "792c",
	"./line-plug.svg": "a6c5",
	"./lock-big.svg": "76c3",
	"./lock.svg": "ad78",
	"./logs-empty-plug.svg": "7083",
	"./modal-info-icon.svg": "dc0c",
	"./new-booking.svg": "f7af",
	"./notifi-error.svg": "295f",
	"./notifi-info.svg": "a8c9",
	"./notifi-success.svg": "c223",
	"./notifi-warn.svg": "5a55",
	"./overbooking-big.svg": "1880",
	"./overbooking.svg": "2001",
	"./payment-success.svg": "33d9",
	"./person-blue.svg": "4288",
	"./person-icon.svg": "3577",
	"./phone-icon-black.svg": "127f",
	"./phone-icon.svg": "ddde",
	"./pie-plug.svg": "8997",
	"./preloader.svg": "779d",
	"./r_k.svg": "13a8",
	"./reservation.svg": "372a",
	"./search-big-icon.svg": "8035",
	"./search-black-icon.svg": "b8e5",
	"./search-icon.svg": "3e7d",
	"./search-input.svg": "a6e1",
	"./sms.svg": "31ba",
	"./switcher-next.svg": "ba03",
	"./switcher-prev.svg": "6ee6",
	"./table-settings.svg": "af86",
	"./tg-icon-black.svg": "4d57",
	"./tg-icon.svg": "385e",
	"./uiw_pay.svg": "2f96",
	"./users.svg": "3149",
	"./waiting-list.svg": "b74b",
	"./warning-triangle-icon.svg": "046c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0591";